import { render, staticRenderFns } from "./DeleteConfigurationConfirm.vue?vue&type=template&id=6dc8f0e9&"
import script from "./DeleteConfigurationConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfigurationConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports